export const isEmpty: (string) => boolean = (str: string) => !str || str.length === 0;

export const trimTrailingSlash = (string: string) => string.replace(/\/$/, '');

export const capitalizeFirstLetter = ([first, ...rest]: string, locale: string = navigator.language): string =>
  [first.toLocaleUpperCase(locale), ...rest].join('');

export const escapeString = (text: string) => text.replace(/'/g, "\\'");

/**
 * Returns text replacing accented characters
 * @param text
 */
export const normalizeString = (text: string) => {
  if (!text) {
    return text;
  }
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
};

export const cleanDoubleSlashes = (urlString: string) => urlString.replace(/\/\//g, '/');

export const cleanUrl = (urlString: string) => trimTrailingSlash(cleanDoubleSlashes(urlString));

export const prependStringWithCharacter = (string: string, character: string, length: number) => {
  if (string.length > length) {
    return string;
  }
  return `${character.repeat(length - string.length)}${string}`;
};

export const removeLineBreaks = (text: string): string => {
  if (!text) {
    return '';
  }
  return text.replace(/[\n\r]+/g, '');
};

export const convertToTitleCase = (input: string): string =>
  input
    ?.split('_')
    ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    ?.join(' ');

/**
 * Type guard to ensure a value is either a string or undefined.
 * Useful for sanitizing configuration values before passing to initialization functions.
 * @param value - The value to check
 * @returns The value if it's a string, otherwise undefined
 * @example
 * const config = { apiKey: 'abc123' };
 * const key = ensureStringOrUndefined(config.apiKey); // 'abc123'
 * const missing = ensureStringOrUndefined(config.missing); // undefined
 * const number = ensureStringOrUndefined(123); // undefined
 */
export const ensureStringOrUndefined = (value: unknown): string | undefined => (typeof value === 'string' ? value : undefined);
